export default __webpack_public_path__ + "static/media/visa-1.af3caace.png";